import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { Typography } from "@/components/ui/typography";

function NotFoundPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate("/");
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center space-y-6 max-w-md mx-auto px-4">
        {/* Large 404 Number */}
        <div className="space-y-4">
          <Typography
            variant="h1"
            className="text-6xl md:text-8xl font-bold text-muted-foreground"
          >
            404
          </Typography>

          {/* Error Message */}
          <Typography
            variant="h2"
            className="text-2xl md:text-3xl font-semibold"
          >
            {t("common.error.pageNotFound.title", "Page Not Found")}
          </Typography>

          <Typography variant="p" className="text-muted-foreground">
            {t(
              "common.error.pageNotFound.description",
              "The page you're looking for doesn't exist. It might have been moved, deleted, or you entered the wrong URL."
            )}
          </Typography>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button onClick={handleGoHome} className="w-full sm:w-auto">
            {t("common.error.pageNotFound.goHome", "Go to Home")}
          </Button>

          <Button
            onClick={handleGoBack}
            variant="outline"
            className="w-full sm:w-auto"
          >
            {t("common.error.pageNotFound.goBack", "Go Back")}
          </Button>
        </div>

        {/* Additional Help Text */}
        <div className="pt-4 border-t border-border">
          <Typography variant="small" className="text-muted-foreground">
            {t(
              "common.error.pageNotFound.helpText",
              "If you believe this is an error, please contact support."
            )}
          </Typography>
        </div>
      </div>
    </div>
  );
}

export default NotFoundPage;
